import { useEffect, useState } from 'react';
import {
  createNewLegalIdentifier,
  ILegalIdentifierSettings,
  getAllLegalIdentifiersSettings,
  updateLegalIdentifierStatus,
} from 'wisestep-api';

import DialogWithInput from '../../../components/dialogWithInput';
import { useWorkspaceContext } from '../../../context';
import { AtsCustomAPIAccess, useAtsCustomAPIAccess } from '../../../hooks/useAtsCustomAPIAccess';
import { failed, success, warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import {
  ClientBreadCrumbListAndTitle,
  legalIdentifierDefaultPayload,
} from '../helper/ClientSettingsHelper';
import { updateStatusQuery } from '../types';

import ClientSettingsLayout, { ILabelWithStatus } from './ClientSettingsLayout';

const LegalIdentifierSettings = () => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [flag, setFlag] = useState<boolean>(false);
  const [legalIdentifier, setLegalIdentifier] = useState<ILegalIdentifierSettings[]>([]);
  const setNotification = useNotificationStore((state) => state.setNotification);

  const workspaceContext = useWorkspaceContext();
  const { access: atsCustomAccessControl } = useAtsCustomAPIAccess([
    AtsCustomAPIAccess.MANAGE_CLIENT_SETTINGS,
  ]);

  const manageAccess = workspaceContext.owns || atsCustomAccessControl[0];

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllLegalIdentifiersSettings();
      setLegalIdentifier(response.data);
    };
    fetchData();
  }, [flag]);

  const categories: ILabelWithStatus[] =
    legalIdentifier?.map((category) => ({
      label: category.name ?? '',
      labelTwo: category.country ?? '',
      status: category.active ?? false,
    })) ?? [];

  const onAddLegalIdentifier = async (data) => {
    if (!manageAccess) {
      setNotification(warning('You do not have enough permissions to perform this action'));
      return;
    }
    const payload = { ...legalIdentifierDefaultPayload };
    payload.name = data.fieldOne;
    payload.country = data.country;
    try {
      await createNewLegalIdentifier(payload);
      setFlag(!flag);
      setNotification(success(`${data.fieldOne} has been added successfully !!`));
      setOpenDialog(false);
    } catch (error: any) {
      if (error.response.status === 400)
        setNotification(warning(`Oops , ${data.fieldOne} already exists!!`));
      else setNotification(failed('Something went wrong !!'));
    }
  };

  const onUpdate = async (data: boolean, index: number) => {
    const tempPayload = legalIdentifier[index];
    updateStatusQuery.active = data;
    try {
      if (tempPayload.id) {
        await updateLegalIdentifierStatus(tempPayload.id, updateStatusQuery);
        setNotification(success('Legal Identifier has been updated successfully !!'));
        setFlag(!flag);
      } else setNotification(warning('File Category Id not found !!'));
    } catch {
      setNotification(failed('Something went wrong , Please try again !!'));
    }
  };

  return (
    <>
      <ClientSettingsLayout
        breadCrumbAndTitle={ClientBreadCrumbListAndTitle['LEGAL_IDENTIFIERS']}
        backUrl={'/app-settings/clients'}
        headerList={['Identifier Type', 'Country', 'Visibility']}
        dataCallback={(data: boolean, index: number) => onUpdate(data, index)}
        itemsList={categories}
        addButtonText="Identifier"
        handleAddButton={() => setOpenDialog(true)}
      />
      <DialogWithInput
        openDialog={openDialog}
        closeDialog={() => setOpenDialog(false)}
        onInput={(data) => onAddLegalIdentifier(data)}
        name="Legal Identifier"
        requireCountriesSelect={true}
      />
    </>
  );
};

export default LegalIdentifierSettings;
